import { Exclude, Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnLprNotification extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public contactEmail: string;

  @Expose()
  public to: string;

  @Expose()
  public provideData: boolean;

  @Expose()
  public callbackMessage: string;

  @Expose()
  public objectId: string;

  @Expose()
  public organization: string;

  @Expose()
  public contactUser: string;

  @Expose()
  public callbackContact: string;

  @Expose()
  public contentType: number;

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public updatedAt: Date;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createdAt: Date;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
